<template>
  <div class="charge-rlue-info">
	<div v-for="p in chargeRule" :key="p.id">
		<h4  v-if="p" v-show="chargeRule.length>1">&nbsp;&nbsp;{{p.parkAreaName}}区域</h4>
		<table class="charge-rlue-table pure-table pure-table-horizontal" v-if="p && p.visitorChargeRule && p.visitorChargeRule.ruleType=='PERIOD_CHARGE'">
			<tr v-for="r in p.visitorChargeRule.periodRules" :key="r.id">
				<td class="charge-rule-time">
					<div v-show="r.startTime!=r.endTime">{{r.startTime + ' - '+ r.endTime}}</div>
					<div v-show="r.startTime==r.endTime">全天</div>
				</td>
				<td>
					<div class=charge-rule-desc>
						&yen;{{r.unitPrice}}/{{r.timeUnit * 60|duration}} 
						<span v-show="r.topPrice>0">, &yen;{{r.topPrice}}封顶</span>
					</div>
				</td>
			</tr>
		</table>
		<div  v-if="p && p.visitorChargeRule" class="more"> 注: 
      <span v-show="p.visitorChargeRule.freeTime > 0">停车{{p.visitorChargeRule.freeTime|duration}}内免费; </span>
      <span v-show="p.visitorChargeRule.chargeCeiling24h > 0">{{p.visitorChargeRule.ceilingHours}}小时&yen;{{p.visitorChargeRule.chargeCeiling24h}}封顶; </span>
    </div>
	</div>
</div>
</template>
<script>
export default {
  name: 'ChargeRule',
  props: {
    chargeRule : Array
  }
}
</script>
<style lang="less" scoped>
.charge-rlue-info{font-size: 0.8em;background-color: #FEFEFE}
.charge-rlue-info .charge-rlue-table{width: 100%;border-spacing: 0;border-collapse: collapse;}
.charge-rlue-info .charge-rlue-table td{border: 0.5px solid #eaeaea;padding:6px 10px;margin: 0;border-left-width: 0;border-right-width: 0;}
.charge-rlue-info .more{padding: 8px 10px}
.charge-rlue-info h5{margin: 10px 0 0 10px;font-size: 1em;color: gray}
.charge-rlue-info ul{margin-top: 0;padding-bottom: 10px;padding-left: 2em;;color: gray;margin-left: 2em;position: relative;padding-top: 10px}
.charge-rlue-info ul:before{content: '注:';position: absolute;left: -1.1em;top: 0.52em;}
.charge-rlue-info ul li{line-height: 1.4em}
</style>